;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Pay",
  props: ["callback_url", "request_type", "customer_allowed"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      pin: null,
      msisdn: null,
      accounts: [],
      type: "none",
      error_message: null,
      processing: false,
      selected_account: null,
      sys_name: null,
      can_view_accounts: false,
      show_otp_page: false,
      one_time_pin_code: null,
      success_message: null,
      hide_account_page: false,
      base_url: "",
      customer_allowed_to_transact: false,
      part_payment: false,
      balance: 0,
      payment_type: null,
      payment_mode_amount: null,
      loading: false,
      partial_payment_allowed: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    $("#pesaflowAccountProcessingModal").on("shown.bs.modal", function () {
      _this.resetModal();
    });

    this.initializeAttributes();
    this.set_total_amount();
    this.setTransactionType();
  },

  methods: {
    resetModal: function resetModal() {
      this.msisdn = null;
      this.pin = null;
      this.processing = false;
      this.error_message = null;
      this.selected_account = null;
      this.accounts = [];
      this.can_view_accounts = false;
      this.hide_account_page = true;
      this.success_message = null;
      this.one_time_pin_code = null;
      this.show_otp_page = false;
      $("#main_page").show();
      $("#account_page").hide();
    },
    initializeAttributes: function initializeAttributes() {
      var attrs = this.$attrs;
      this.invoice_number = attrs.invoice_no;
      this.invoice_amount = attrs.amount_net;
      this.currency = attrs.currency;
      this.fee = attrs.fee;
      this.agent_fee = attrs.agent_fee;
      this.url = attrs.status_api_url;
      this.logo = attrs.logo;
      this.consumer_secret = attrs.con_secret;
      this.consumer_key = attrs.con_key;
      this.sys_name = attrs.sys_name;
      this.base_url = attrs.base_url;
      this.partial_payment_allowed = attrs.partial_payment_allowed === "true" || attrs.partial_payment_allowed === true;
    },
    setTransactionType: function setTransactionType() {
      if (this.customer_allowed === "false" || this.customer_allowed === false) {
        this.type = "agent";
        this.customer_allowed_to_transact = false;
      } else {
        this.type = null;
        this.customer_allowed_to_transact = true;
      }

      if (!this.partial_payment_allowed) {
        this.part_payment = false;
        this.payment_type = "full";
        this.setPaymentModeAmount("full");
      } else {
        this.part_payment = true;
      }
    },
    setPaymentModeAmount: function setPaymentModeAmount(type) {
      if (type === "full") this.payment_mode_amount = this.total_amount;
      if (type === "partial") this.payment_mode_amount = null;
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    authenticate: function authenticate() {
      var _this2 = this;

      this.error_message = null;
      this.processing = false;
      if (!this.msisdn || !this.pin) {
        this.error_message = "Phone number and/or PIN is missing!";
        return;
      }

      if (!this.validate_msisdn(this.msisdn)) {
        this.error_message = "Provide a valid phone number";
        return;
      }

      if (!this.type) {
        this.error_message = "Please specify a Customer or Agent account";
        return;
      }
      var auth_url = this.base_url + "/api/" + this.type + "/co/authenticate";
      var payload = {
        msisdn: this.msisdn,
        pin: this.pin,
        invoice_number: this.invoice_number
      };
      this.loading = true;

      Vue.axios.post(auth_url, payload).then(function (response) {
        _this2.loading = false;
        _this2.can_view_accounts = true;
        _this2.show_otp_page = false;
        _this2.accounts = response.data.filter(function (v) {
          return v.currency === _this2.currency;
        });
        _this2.balance = Number(_this2.accounts[0].balance);
        _this2.can_view_accounts = true;
        _this2.agent_fee = Number(_this2.agent_fee) + Number(_this2.accounts[0].agent_fee) || 0;
        _this2.total_amount = Number(_this2.total_amount) + Number(_this2.agent_fee);

        $("#main_page").hide();
      }).catch(function () {
        _this2.loading = false;
        _this2.error_message = "Authentication failed. Please check that your PIN or PhoneNumber is correct !";
      });
    },
    validate_msisdn: function validate_msisdn(msisdn) {
      var found = msisdn.match(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g);
      return found !== null && found.length > 0;
    },
    request_otp: function request_otp() {
      var _this3 = this;

      var otp_url = this.base_url + "/api/" + this.type + "/otp/request";
      var payload = {
        msisdn: this.msisdn
      };
      Vue.axios.post(otp_url, payload).then(function () {
        $("#account_page").hide();
        _this3.show_otp_page = true;
      }).catch(function () {
        _this3.loading = false;
        _this3.error_message = "An error occurred. Try again later !";
      });
    },
    authorize_payment: function authorize_payment() {
      var _this4 = this;

      this.error_message = null;
      var authorize_url = this.base_url + "/api/" + this.type + "/co/make/payment";
      var found = this.accounts.filter(function (v) {
        return v.id === _this4.selected_account;
      });

      if (!this.one_time_pin_code) {
        this.error_message = "Enter the code received on your phone/email";
        return;
      }

      if (!this.selected_account) {
        this.error_message = "Select an account to pay from !";
        return;
      }

      if (parseFloat(found[0].balance) <= 0) {
        this.error_message = "Account has insufficient funds !";
        return;
      }

      if (parseFloat(found[0].balance) < parseFloat(this.payment_mode_amount)) {
        this.error_message = "Account has insufficient funds !";
        return;
      }

      this.processing = true;
      var payload = {
        otp: this.one_time_pin_code,
        invoice_number: this.invoice_number,
        authorized_amount: this.payment_mode_amount,
        pesaflow_account_id: this.selected_account,
        msisdn: this.msisdn
      };
      Vue.axios.post(authorize_url, payload).then(function () {
        _this4.processing = false;
        _this4.can_view_accounts = false;
        _this4.show_otp_page = false;
        _this4.type = null;
        _this4.msisdn = null;
        _this4.pin = null;
        _this4.one_time_pin_code = null;
        _this4.success_message = "Your payment of " + _this4.currency + "." + _this4.payment_mode_amount + " for invoice " + _this4.invoice_number + " was successful. Redirecting you ...";
        $("#main_page").show();
        $("#account_page").hide();

        setInterval(function () {
          _this4.redirect();
        }, 2500);
      }).catch(function () {
        _this4.processing = false;
        _this4.error_message = "Payment failed. Try again Later !";
      });
    },
    redirect: function redirect() {
      if (this.callback_url && this.callback_url.length > 0) {
        window.top.location.href = this.callback_url;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"pesaflowAccountProcessingModal","tabindex":"-1","role":"dialog","aria-labelledby":"pesaflowAccountProcessingModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using "+_vm._s(_vm.sys_name)+" Account")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                    "+_vm._s(_vm.currency)+" "+_vm._s(_vm.formatNumber(_vm.total_amount))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.error_message)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.error_message)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.success_message)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('span',{staticClass:"spinner-border spinner-border",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                    Please wait, loading ...\n                  ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('br'):_vm._e(),_vm._v(" "),(!_vm.can_view_accounts && !_vm.success_message)?_c('div',{attrs:{"id":"main_page"}},[_c('form',[_c('label',{attrs:{"for":"email"}},[_vm._v("Mobile Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msisdn),expression:"msisdn"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Enter your phone number"},domProps:{"value":(_vm.msisdn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msisdn=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"pin"}},[_vm._v("PIN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin),expression:"pin"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter your PIN","maxlength":"4"},domProps:{"value":(_vm.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pin=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.customer_allowed_to_transact)?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"inlineCheckbox1","value":"customer"},domProps:{"checked":_vm._q(_vm.type,"customer")},on:{"change":function($event){_vm.type="customer"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox1"}},[_vm._v("Customer")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-check-input",attrs:{"type":"radio","id":"inlineCheckbox2","value":"agent"},domProps:{"checked":_vm._q(_vm.type,"agent")},on:{"change":function($event){_vm.type="agent"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"inlineCheckbox2"}},[_vm._v(_vm._s(_vm.sys_name)+" Agent")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[_c('a',{staticClass:"btn btn-sm btn-outline-primary lift",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.authenticate.apply(null, arguments)}}},[_vm._v("Proceed")])])])]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('div',[_c('span',{staticClass:"spinner-border spinner-border",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                    Please wait, processing payment ...\n                  ")]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('br'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.can_view_accounts && !_vm.show_otp_page),expression:"can_view_accounts && !show_otp_page"}]},[(_vm.balance <= 0)?_c('p',[_vm._v("\n                      You have insufficient balance. Top up your account to\n                      proceed.\n                    ")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"account"}},[_vm._v("Select Account to pay from")]),_vm._v(" "),_c('div',[_vm._l((_vm.accounts),function(account,index){return _c('ul',{key:index},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_account),expression:"selected_account"}],staticClass:"form-check-input",attrs:{"type":"radio","name":account.name,"id":index},domProps:{"value":account.id,"checked":_vm._q(_vm.selected_account,account.id)},on:{"change":function($event){_vm.selected_account=account.id}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":index}},[_vm._v("\n                            "+_vm._s(account.name)+"(\n                            "),_c('b',[_vm._v("\n                              Bal. "+_vm._s(account.currency)+"\n                              "+_vm._s(_vm.formatNumber(account.balance))+"\n                            ")]),_vm._v("\n                            )\n                          ")])])])}),_vm._v(" "),_c('br')],2),_vm._v(" "),(_vm.selected_account)?_c('div',[_c('label',{attrs:{"for":"paymentMode"}},[_vm._v("Select Payment Mode")]),_vm._v(" "),_c('ul',[_c('div',{staticClass:"row"},[(_vm.part_payment)?_c('div',{staticClass:"col-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_type),expression:"payment_type"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"partial"},domProps:{"checked":_vm._q(_vm.payment_type,"partial")},on:{"click":function($event){return _vm.setPaymentModeAmount('partial')},"change":function($event){_vm.payment_type="partial"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v(" Partial ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_type),expression:"payment_type"}],staticClass:"form-check-input",attrs:{"type":"radio","value":"full"},domProps:{"checked":_vm._q(_vm.payment_type,"full")},on:{"click":function($event){return _vm.setPaymentModeAmount('full')},"change":function($event){_vm.payment_type="full"}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label"},[_vm._v(" Full ")])])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_mode_amount),expression:"payment_mode_amount"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Amount","readonly":_vm.payment_type === 'full'},domProps:{"value":(_vm.payment_mode_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.payment_mode_amount=$event.target.value}}}),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[(_vm.selected_account && _vm.payment_mode_amount && _vm.balance > 0)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"#"},on:{"click":_vm.request_otp}},[_vm._v("Proceed")]):_vm._e()])]),_vm._v(" "),(_vm.show_otp_page)?_c('div',[_c('label',{attrs:{"for":"otp"}},[_vm._v("Enter One Time Pin sent to your phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.one_time_pin_code),expression:"one_time_pin_code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Code Received","maxlength":"8"},domProps:{"value":(_vm.one_time_pin_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.one_time_pin_code=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[(_vm.one_time_pin_code)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"#"},on:{"click":_vm.authorize_payment}},[_vm._v("Confirm Payment")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_vm._m(1)])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-10c51c28", __vue__options__)
  } else {
    hotAPI.reload("data-v-10c51c28", __vue__options__)
  }
})()}